import { render, staticRenderFns } from "./PosDemo.vue?vue&type=template&id=30afdeed&scoped=true&"
import script from "./PosDemo.vue?vue&type=script&lang=js&"
export * from "./PosDemo.vue?vue&type=script&lang=js&"
import style0 from "../components/css/Style.css?vue&type=style&index=0&id=30afdeed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30afdeed",
  null
  
)

export default component.exports